import {createStore, applyMiddleware, combineReducers} from 'redux'
import {createLogger} from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import {createBrowserHistory} from 'history'
import {routerMiddleware} from 'react-router-redux'

import {apiPrivate} from '../api'
import {User as UserActions} from './actions'

import header from '../sections/header/reducer'
import firstLogin from '../sections/firstlogin/reducers'
import login from './login/reducers' //TODO get rid of this
import loginComponent from '../sections/login/reducer' //TODO rename to login
import signupComponent from '../sections/signup/reducer' //TODO change name
import domain from './reducers'
import profile from '../sections/profile/reducer'
import activity from '../sections/activity/reducer'
import missingInfo from '../sections/missingInfo/reducer'
import community from '../sections/community/reducer'
import yours from '../sections/yours/reducer'
import catalog from '../sections/catalog/reducer'
import shared from '../sections/shared/reducer'
import item from '../sections/items/reducer'
import yourItem from '../sections/yourItems/reducer'
import deposit from '../sections/deposit/reducer'
import depositV2 from '../sections/depositV2/reducer'
import rent from '../sections/rent/reducer'
import rentV2 from '../sections/rentV2/reducer'
import remove from '../sections/remove/reducer'
import confirmEmail from '../sections/confirmEmail/reducer'
import balance from '../sections/balance/reducer'
import billing from '../sections/billing/reducer'
import help from '../sections/help/reducer'
import terms from '../sections/terms/reducer'
import termsDeposit from '../sections/termsDeposit/reducer'
import addCreditCard from '../sections/addCreditCard/reducer'
import common from '../common/reducer'
import config from '../config'

export const history = createBrowserHistory()
const routeMiddleware = routerMiddleware(history)

const loggerMiddleware = createLogger()

function restoreState() {
  const state = {
    domain: {
      user: {
        id: 0,
        email: '',
        name: '',
        lastName: '',
        permissions: [],
        token: '',
        items: 0,
        phone: '',
      },
    },
  }

  const user = UserActions.getLocal()
  if (user === null) {
    localStorage.clear()
  } else {
    state.domain.user = {...state.domain.user, ...user}
    apiPrivate.defaults.headers.Authorization = state.domain.user.token
  }

  return state
}

const middleware = [
  thunkMiddleware,
  routeMiddleware,
]
if (config.ENV === 'development') {
  middleware.push(loggerMiddleware)
}

const store = createStore(
  combineReducers({
    domain,
    firstLogin,
    ui: combineReducers({
      header,
      login,
      profile,
      activity,
      missingInfo,
      community,
      yours,
      catalog,
      shared,
      item,
      yourItem,
      deposit,
      depositV2,
      rent,
      rentV2,
      remove,
      common,
      confirmEmail,
      loginComponent,
      signupComponent,
      balance,
      billing,
      help,
      terms,
      termsDeposit,
      addCreditCard
    }),
  }),
  restoreState(),
  applyMiddleware(...middleware),
)

export default store



// WEBPACK FOOTER //
// ./src/state/store.js